// extracted by mini-css-extract-plugin
export default {"card":"card-module--card--3FX0T","isElevated":"card-module--isElevated--3yrRG","disabled":"card-module--disabled--2mC5x","square":"card-module--square--11lcI"};